import { UtilService } from './../util.service';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './../base/base.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalculatedPotencialService extends BaseService<any>{
  serviceName: string = "potenciais-calculado";

  constructor(
    protected http: HttpClient,
    protected utilService: UtilService
  ) {
    super(http, utilService);
  }

  getByIdPublic(id: number){
    return this.http.get<any>(this.urlApi + "public/" + this.serviceName + '/' + id);
  }
}
